import analytics from '../../analytics';
import { TAB_SHOW_EVENT } from '../tabs';
const getTracking = () => JSON.parse(document.querySelector('[data-tracking]').dataset.tracking);
export default () => {
    document.querySelectorAll('[role="tabpanel"]').forEach((tabPanel) => {
        tabPanel.addEventListener(TAB_SHOW_EVENT, (event) => {
            const tabId = event.detail.id;
            if (tabId === 'tab-panel-product-details') {
                analytics.productTabDetail(getTracking());
            }
        });
        if (tabPanel.id === 'tab-panel-more-products-top') {
            const originTracking = getTracking();
            tabPanel.querySelectorAll('.c-slider__item').forEach((sliderItem, index) => {
                const productCard = sliderItem.querySelector('.c-card');
                const trackingElement = productCard?.querySelector('[data-tracking]');
                if (!trackingElement?.dataset.tracking)
                    return;
                const productData = JSON.parse(trackingElement.dataset.tracking);
                const enrichedProductData = {
                    ...productData,
                    productPosition: index + 1,
                    originProduct: originTracking,
                };
                const cardLink = sliderItem.querySelector('.c-card__link');
                cardLink?.addEventListener('click', () => {
                    analytics.productYouMaybeAlsoLikeClicked({ ...enrichedProductData, zone: 'Produit' });
                });
                const wishlistButton = sliderItem.querySelector('[data-component="wishlist-item"]');
                wishlistButton?.addEventListener('click', () => {
                    analytics.productYouMaybeAlsoLikeClicked({ ...enrichedProductData, zone: 'Favoris' });
                });
                const productNameInside = sliderItem.querySelector('.c-product-preview__overlay-title a');
                productNameInside?.addEventListener('click', () => {
                    analytics.productYouMaybeAlsoLikeClicked({ ...enrichedProductData, zone: 'Produit' });
                });
                const variantLinks = sliderItem.querySelectorAll('.c-product-preview__overlay-variants a');
                variantLinks.forEach((variantLink) => {
                    variantLink.addEventListener('click', () => {
                        analytics.productYouMaybeAlsoLikeClicked({ ...enrichedProductData, zone: 'Autre variant' });
                    });
                });
                const sizeLinks = sliderItem.querySelectorAll('.c-product-preview__overlay-sizes a');
                sizeLinks.forEach((sizeLink) => {
                    sizeLink.addEventListener('click', () => {
                        analytics.productYouMaybeAlsoLikeClicked({ ...enrichedProductData, zone: 'Produit' });
                    });
                });
                const quickShopButton = sliderItem.querySelector('button[data-role="quickshop"]');
                quickShopButton?.addEventListener('click', () => {
                    analytics.productYouMaybeAlsoLikeClicked({ ...enrichedProductData, zone: 'Quick shop' });
                });
                const productNameOutside = sliderItem.querySelector('.c-product-preview__title a');
                productNameOutside?.addEventListener('click', () => {
                    analytics.productYouMaybeAlsoLikeClicked({ ...enrichedProductData, zone: 'Produit' });
                });
            });
        }
    });
};
